export default __webpack_public_path__ + "static/media/399.1fbdcebc.png";